import { api } from './api'

const apiVersion = 'v2'

export const cuttingTechnologiesApi = api
    .enhanceEndpoints({
        addTagTypes: ['CuttingTechnologies', 'MaterialThicknesses', 'ThicknessSheets'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getCuttingTechnologies: builder.query({
                query: ({ organisationId, params }) => ({
                    url: `/${apiVersion}/organisation/${organisationId}/cutting-technologies`,
                    params,
                }),
                transformResponse: (response) => {
                    delete response.$type

                    return response
                },
                providesTags: (result, _error, _arg) =>
                    result
                        ? [
                              { type: 'CuttingTechnologies', id: 'LIST' },
                              ...(Object.keys(result).map((cuttingTechnologyId) => ({
                                  type: 'CuttingTechnologies',
                                  id: cuttingTechnologyId,
                              })) ?? []),
                          ]
                        : [{ type: 'CuttingTechnologies', id: 'LIST' }],
            }),

            getCuttingTechnology: builder.query({
                query: ({ cuttingTechnologyId, organisationId }) => ({
                    url: `/${apiVersion}/organisation/${organisationId}/cutting-technologies/${cuttingTechnologyId}`,
                }),
                providesTags: (_result, _error, arg) => [{ type: 'CuttingTechnologies', id: arg.cuttingTechnologyId }],
            }),

            getCuttingTechnologyMaterials: builder.query({
                query: ({ cuttingTechnologyId, organisationId }) => ({
                    url: `/${apiVersion}/organisation/${organisationId}/cutting-technologies/${cuttingTechnologyId}/materials`,
                    method: 'GET',
                }),
                transformResponse: (response) => {
                    return response?.sort((a, b) => {
                        if (a.materialName?.toLocaleLowerCase() < b.materialName?.toLocaleLowerCase()) {
                            return -1
                        }
                        if (a.materialName?.toLocaleLowerCase() > b.materialName?.toLocaleLowerCase()) {
                            return 1
                        }
                        return 0
                    })
                },
            }),

            getMaterialThicknesses: builder.query({
                query: ({ cuttingTechnologyId, materialId, organisationId, params }) => ({
                    url: `/${apiVersion}/organisation/${organisationId}/cutting-technologies/${cuttingTechnologyId}/materials/${materialId}/thicknesses`,
                    method: 'GET',
                    params,
                }),
                providesTags: ['MaterialThicknesses'],
            }),
            getThicknessSheets: builder.query({
                query: ({ cuttingTechnologyId, materialId, organisationId, params }) => ({
                    url: `/${apiVersion}/organisation/${organisationId}/cutting-technologies/${cuttingTechnologyId}/materials/${materialId}/thicknesses/sheets`,
                    method: 'GET',
                    params,
                }),
                providesTags: ['ThicknessSheets'],
            }),
        }),
    })

export const {
    useGetCuttingTechnologiesQuery,
    useGetCuttingTechnologyQuery,
    useLazyGetCuttingTechnologyMaterialsQuery,
    useLazyGetMaterialThicknessesQuery,
    useLazyGetThicknessSheetsQuery,
} = cuttingTechnologiesApi
